// extracted by css-extract-rspack-plugin
export default {"small_button":"SatUC","smallButton":"SatUC","large_button":"mG6iH","largeButton":"mG6iH"};